/****************************************************
 * Module Name:  commonStoneSelection.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Box, IconButton, Tooltip, } from "@mui/material";
import "./../../style/modalstyle.css";
import StoneSelectionModal from "./stoneSelectionModal";
import QueueIcon from '@mui/icons-material/Queue';

const CommonStoneSelection = ({ title, handleSelection, bgColor, buttonDisabled }) => {
    const [showModal, setshowModal] = useState(false);

    const handleClick = () => {
        setshowModal(true)
    }

    const handleSave = (data) => {
        handleSelection(data)
    }

    return (
        <div>
            <Box>
                {showModal ? (
                    <StoneSelectionModal
                        show={showModal}
                        handleSave={handleSave}
                        handleClose={() => setshowModal(false)}
                        title={title}
                    />
                ) : null}
                <Tooltip title={title}>
                    <IconButton
                        color={bgColor ? "inherit" : "info"}
                        onClick={handleClick}
                        disabled={buttonDisabled}
                        sx={{
                            color: '#454545',
                            borderColor: '#454545'
                        }}
                    >
                        <QueueIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </div>
    );
};

export default CommonStoneSelection;
